import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { TriggerType } from "../../../../../common/interfaces/flow/trigger/TriggerType";
import IssuePreviewAction from "../../../../../connections/atlassian/jira/components/IssuePreviewAction";
import PreviewAction from "./PreviewAction";
import Tooltip from "@atlaskit/tooltip";

const MenuSectionExtensions = ({ action }) => {
  const flow = useSelector((state) => state.integration.flow);
  useEffect(() => {}, [flow]);

  return (
    <div className="ihub-actionmenu-icons">
      <Tooltip position="top" content="Fetch an issue from Jira and preview what this action evaluates to">
        {flow.trigger.type === TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE && <IssuePreviewAction action={action} />}
        <PreviewAction />
      </Tooltip>
    </div>
  );
};
export default MenuSectionExtensions;
